export class TabsState {
  /**
   * @var {object }
   */
  activeTabState = {};
}
